import React, { useState } from "react"
import { Row, Col, Container, breakpointsMax } from "../res/styles/Common"
import styled from "styled-components"
import Colors from "../res/styles/Colors"
import { SectionBody, SectionTitle } from "../res/styles/TextStyles"
import { baseurl } from "../config"
import Button from "../Atoms/Button"
import { useMediaQuery } from "react-responsive"
import { useTranslation } from "react-i18next"
import axios from "axios"

const Input = styled.input`
    width: 220px;
    height: 50px;
    border: 1px solid transparent;
    border-radius: 8px;
    background-color: ${Colors.secondary_grey};
    margin-right: ${(props) => (props.isMobile ? "" : "15px")};
    margin-bottom: 15px;
    padding-left: 10px;
    font-family: "EB Garamond", serif;
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;

    &::placeholder {
        color: ${Colors.lightgrey};
    }

    &:first-child {
        margin-top: ${(props) => (props.isMobile ? "20px" : "")};
    }

    &:focus,
    &:hover {
        outline-color: ${Colors.red};
    }
`

const TextArea = styled.textarea`
    width: 220px;
    height: 122px;
    border: 1px solid transparent;
    border-radius: 8px;
    background-color: ${Colors.secondary_grey};
    resize: none;
    font-family: "EB Garamond", serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    font-size: 18px;
    padding-left: 10px;
    padding-top: 10px;
    margin-bottom: 15px;

    &::placeholder {
        color: ${Colors.lightgrey};
    }

    &:focus,
    &:hover {
        outline-color: ${Colors.red};
    }
`

const TextContainer = styled.div`
    white-space: pre-line;
    max-width: 495px;
    width: 100%;
`

const Bg = styled.div`
    margin: 100px;
`

function Form() {
    const isMobile = useMediaQuery({ query: breakpointsMax.tablet })
    const { t } = useTranslation()
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: "",
    })

    const onChange = (e) => {
        setForm({ ...form, [e.target.id]: e.target.value })
    }

    const onSubmit = () => {
        if (form.name === "" || form.email === "" || form.message === "") {
            return alert(t("contacts.messages.fields"))
        }

        axios
            .post(`${baseurl}/mailsender.php`, {
                from: form.email,
                name: form.name,
                body: form.message,
            })
            .then((res) => {
                if (res.data.status) {
                    return alert(t("contacts.messages.sent"))
                }
                return alert(t("contacts.messages.error"))
            })
            .catch((err) => alert(t("contacts.messages.error")))
    }

    return (
        <Container>
            <Col align="center">
                <Row justify="center">
                    <Col justify="center">
                        <Input
                            id="name"
                            placeholder={t("contacts.form.name")}
                            isMobile={isMobile}
                            value={form.name}
                            onChange={onChange}
                            type="text"
                        />
                        <Input
                            id="email"
                            placeholder={t("contacts.form.email")}
                            isMobile={isMobile}
                            value={form.email}
                            onChange={onChange}
                            type="email"
                        />
                    </Col>
                    <TextArea
                        id="message"
                        placeholder={t("contacts.form.message")}
                        value={form.message}
                        onChange={onChange}
                    />
                </Row>
                <Button
                    big
                    borderColor={Colors.red}
                    textColor={Colors.white}
                    bgColor={Colors.red}
                    onClick={onSubmit}
                >
                    <SectionBody>{t("contacts.form.send")}</SectionBody>
                </Button>
            </Col>
        </Container>
    )
}

function Contacts() {
    const { t } = useTranslation()

    return (
        <Container>
            <Bg>
                <Row justify="center">
                    <Col>
                        <TextContainer>
                            <SectionTitle style={{ marginBottom: "50px" }}>
                                {t("contacts.title")}
                            </SectionTitle>
                            <SectionBody
                                textColor={Colors.grey}
                                align="left"
                                fontWeight="500"
                            >
                                {t("contacts.body")}
                            </SectionBody>
                        </TextContainer>
                    </Col>
                    <Form />
                </Row>
            </Bg>
        </Container>
    )
}

export default Contacts
